var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auto-loading"},[_c('van-loading',{attrs:{"size":"24","type":"spinner","vertical":"","color":"#1989fa"}},[_vm._v("\n    "+_vm._s(_vm.promptCopy)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }